import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

// The dayjs locales stop at days (then jump to months), but the match
// cards and the chat roll into weeks after six days with no upper cap —
// so the locales need week strings for the scoped formatter in
// utils/helpers/relativeTime.js (verboseTimeAgo). German mirrors the de
// locale's own [standalone, dative] function style ("vor einer Woche").
const GERMAN_WEEK_FORMS = {
  w: ['eine Woche', 'einer Woche'],
  ww: ['%d Wochen', '%d Wochen']
};

function germanWeek(number, withoutSuffix, key) {
  const text = GERMAN_WEEK_FORMS[key][withoutSuffix ? 0 : 1];
  return text.replace('%d', number);
}

export const WEEK_RELATIVE_TIME = {
  sv: { w: 'en vecka', ww: '%d veckor' },
  nl: { w: 'een week', ww: '%d weken' },
  de: { w: germanWeek, ww: germanWeek },
  da: { w: 'en uge', ww: '%d uger' },
  en: { w: 'a week', ww: '%d weeks' }
};

// Installs the relativeTime plugin with its DEFAULT thresholds and
// rounding — fromNow() keeps minutes → hours → days → months → years
// everywhere (notification center, request cards). The card ↔ chat
// timestamp sync does not live here: it's scoped to the shared
// formatter in utils/helpers/relativeTime.js, which only needs the
// week strings injected below. Call after the language's locale file
// has been loaded.
export function configureRelativeTime(dayjsInstance, lang) {
  dayjsInstance.extend(relativeTime);
  dayjsInstance.extend(updateLocale);

  const weekForms = WEEK_RELATIVE_TIME[lang];
  const locale = dayjsInstance.Ls[lang];
  if (weekForms && locale) {
    dayjsInstance.updateLocale(lang, {
      relativeTime: { ...locale.relativeTime, ...weekForms }
    });
  }
}

export default { configureRelativeTime };
